import React, { useEffect, useRef, useState } from 'react';
import * as styles from './Standards.module.scss';
const CaretClosed = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 9",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#A3A3A3",
  d: "M17 1 9 8 1 1"
}));
const CaretOpen = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 9",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#A3A3A3",
  d: "m1 8 8-7 8 7"
}));
const EvidenceIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 29",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#262626",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.692",
  d: "M17.538 12.16c.422-.75.774-1.427.991-1.941 1.054-2.5.012-5.376-2.535-6.549-2.546-1.173-5.103.044-6.225 2.392C7.623 4.589 4.76 4.806 3.18 7.104c-1.578 2.298-1.083 5.3 1.08 6.938.98.743 2.921 1.839 4.749 2.814m9.377-2.638c-.477-2.559-2.654-4.43-5.395-3.922-2.741.509-4.514 2.982-4.143 5.67.298 2.158 1.941 7.224 2.576 9.132.086.26.13.39.215.482a.57.57 0 0 0 .28.161c.121.029.256.001.525-.054 1.97-.404 7.178-1.514 9.197-2.336 2.512-1.022 3.809-3.792 2.838-6.422-.971-2.63-3.64-3.578-6.093-2.711Z"
}));
const CleanCompositionIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 29",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#262626",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.692",
  d: "M10.155 7.73v5.079c0 .621 0 .932-.077 1.22a2.255 2.255 0 0 1-.334.713c-.172.244-.41.443-.888.84L4.684 19.06c-.477.398-.716.597-.888.84a2.256 2.256 0 0 0-.333.713c-.078.288-.078.6-.078 1.22v.34c0 1.264 0 1.896.246 2.38.216.424.562.769.986.985.483.246 1.115.246 2.379.246h13.088c1.264 0 1.896 0 2.379-.246.424-.216.77-.561.986-.986.246-.483.246-1.115.246-2.378v-.34c0-.622 0-.933-.078-1.22a2.255 2.255 0 0 0-.333-.713c-.172-.244-.41-.443-.888-.841l-4.172-3.477c-.477-.397-.716-.596-.888-.84a2.257 2.257 0 0 1-.333-.713c-.078-.288-.078-.599-.078-1.22v-5.08m-7.56 0h8.35c.316 0 .474 0 .595-.06a.564.564 0 0 0 .246-.247c.061-.12.061-.279.061-.595V4.12c0-.316 0-.474-.061-.594a.564.564 0 0 0-.247-.247c-.12-.061-.278-.061-.594-.061h-8.35c-.316 0-.474 0-.594.061a.564.564 0 0 0-.247.247c-.061.12-.061.278-.061.594v2.708c0 .316 0 .474.061.595.054.106.14.192.247.246.12.062.278.062.594.062Zm-3.16 12.413h14.67c.523 0 .786 0 1.004.043a2.257 2.257 0 0 1 1.773 1.773c.043.218.043.48.043 1.004 0 .525 0 .787-.043 1.005a2.257 2.257 0 0 1-1.773 1.773c-.218.043-.48.043-1.005.043H6.206c-.524 0-.787 0-1.005-.043a2.257 2.257 0 0 1-1.773-1.773c-.043-.218-.043-.48-.043-1.005 0-.524 0-.786.043-1.004a2.257 2.257 0 0 1 1.773-1.773c.218-.043.48-.043 1.005-.043Z"
}));
const ProductionQualityIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 29",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "M3.677 23.397a.846.846 0 1 0 1.672.257l-.836-.129-.836-.128Zm10.114-8.09a.846.846 0 1 0-.505-1.615l.253.808.252.807Zm8.545-9.02-.835.136.835-.136Zm-4.878 14.651.497.685-.497-.685Zm4.04-14.993.48.696-.48-.696Zm-5.703 1.786-.024.845.024-.845ZM8.462 8.859l-.494-.687.494.687Zm2.073 12.077a.846.846 0 1 0-.762 1.511l.381-.756.38-.755ZM5.709 14.5l-.84.1.004.041.01.04.826-.181Zm1.037 3.537a.846.846 0 1 0 1.175-1.218l-.588.61-.587.608Zm-2.233 5.488.836.13c.291-1.89 2.365-6.449 8.442-8.348l-.252-.807-.253-.808c-6.76 2.113-9.232 7.249-9.61 9.705l.837.128ZM22.336 6.287l-.835.136c.316 1.945.344 4.584-.302 7.155-.645 2.567-1.945 5.01-4.238 6.675l.497.685.497.685c2.703-1.962 4.174-4.802 4.885-7.633.71-2.826.679-5.7.331-7.839l-.835.136Zm-.838-.342-.48-.696c-1.288.889-2.602 1.708-5.2 1.636l-.023.846-.024.845c3.11.087 4.781-.95 6.208-1.935l-.48-.696Zm-5.703 1.786.024-.846c-1.204-.034-2.592-.14-3.902-.037-1.34.106-2.71.434-3.95 1.324l.495.687.493.687c.902-.648 1.935-.92 3.095-1.01 1.19-.095 2.398.004 3.721.04l.024-.845Zm1.663 13.207-.497-.684c-2.527 1.833-5.015 1.393-6.426.682l-.381.755-.38.756c1.843.929 5.03 1.463 8.181-.824l-.497-.685ZM8.462 8.858l-.494-.686c-1.364.98-2.22 2.046-2.692 3.169-.471 1.121-.53 2.233-.407 3.26l.84-.101.84-.1c-.098-.817-.042-1.62.287-2.404.33-.784.96-1.617 2.12-2.45l-.494-.687ZM5.709 14.5l-.827.182c.164.742.727 2.26 1.864 3.355l.587-.609.588-.61c-.822-.791-1.268-1.964-1.386-2.5l-.826.182Zm16.627-8.213.835-.136c-.17-1.046-1.349-1.458-2.154-.902l.481.696.48.696a.3.3 0 0 1-.279.028.329.329 0 0 1-.198-.246l.835-.136Z"
}));
const CertifiedSupplierIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 29",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#262626",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.692",
  d: "m10.155 14.5 2.257 2.257 5.077-5.078M8.275 5.27a4.324 4.324 0 0 0 2.46-1.02 4.324 4.324 0 0 1 5.61 0c.692.59 1.553.947 2.46 1.02a4.324 4.324 0 0 1 3.966 3.966 4.323 4.323 0 0 0 1.02 2.46 4.324 4.324 0 0 1 0 5.61 4.323 4.323 0 0 0-1.02 2.46 4.324 4.324 0 0 1-3.966 3.966 4.325 4.325 0 0 0-2.46 1.02 4.324 4.324 0 0 1-5.61 0 4.324 4.324 0 0 0-2.46-1.02 4.324 4.324 0 0 1-3.966-3.966 4.324 4.324 0 0 0-1.02-2.46 4.324 4.324 0 0 1 0-5.61 4.324 4.324 0 0 0 1.02-2.46 4.324 4.324 0 0 1 3.966-3.966Z"
}));
const ExpertFormulasIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 29",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#262626",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.692",
  d: "M19.31 18.289a22.91 22.91 0 0 1-.961 1.021c-4.847 4.847-10.919 6.632-13.562 3.989-1.813-1.813-1.543-5.236.367-8.772m2.619-3.722c.318-.361.652-.718 1.002-1.068 4.847-4.847 10.919-6.632 13.562-3.989 1.814 1.814 1.543 5.24-.371 8.779m-3.617-4.79c4.846 4.846 6.632 10.918 3.988 13.562-2.643 2.643-8.715.858-13.562-3.989C3.93 14.464 2.143 8.392 4.787 5.748c2.643-2.643 8.715-.858 13.562 3.989ZM14.667 14.5a1.128 1.128 0 1 1-2.257 0 1.128 1.128 0 0 1 2.257 0Z"
}));
const Standards = ({
  heading,
  button,
  items,
  backgroundVideo
}) => {
  if (!(items !== null && items !== void 0 && items.length)) return null;
  const {
    0: activeIndex,
    1: setActiveIndex
  } = useState(0);

  // IO + visibility dla tła wideo
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const {
    0: inView,
    1: setInView
  } = useState(false);
  const hasPreloadedRef = useRef(false);

  // IO dwukierunkowy: true gdy sekcja w viewport (z marginesem), false gdy poza
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), {
      root: null,
      rootMargin: '200px',
      threshold: 0.01
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  // Helper do synchronizacji play/pause
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const syncPlayback = () => {
      try {
        // Preload + load tylko raz (pierwsze wejście do viewportu)
        if (inView && !hasPreloadedRef.current) {
          var _v$load;
          v.preload = 'auto';
          (_v$load = v.load) === null || _v$load === void 0 ? void 0 : _v$load.call(v);
          hasPreloadedRef.current = true;
        }
        if (inView && !document.hidden) {
          var _v$play;
          v.muted = true; // autoplay policy
          v.playsInline = true;
          v.loop = true;
          const p = (_v$play = v.play) === null || _v$play === void 0 ? void 0 : _v$play.call(v);
          if (p !== null && p !== void 0 && p.catch) p.catch(() => {});
        } else {
          var _v$pause;
          (_v$pause = v.pause) === null || _v$pause === void 0 ? void 0 : _v$pause.call(v);
        }
      } catch {
        // no-op
      }
    };

    // 1) reaguj na in/out viewport
    syncPlayback();

    // 2) reaguj na zmianę widoczności karty
    const onVisibility = () => syncPlayback();
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [inView]);
  const handleToggle = index => {
    setActiveIndex(prev => prev === index ? -1 : index);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root,
    ref: sectionRef
  }, backgroundVideo && /*#__PURE__*/React.createElement("div", {
    className: styles.rootBackground,
    "aria-hidden": "true"
  }, backgroundVideo.poster && /*#__PURE__*/React.createElement("img", {
    className: styles.rootPoster,
    src: backgroundVideo.poster,
    alt: "",
    loading: "lazy"
  }), backgroundVideo.src && /*#__PURE__*/React.createElement("video", {
    className: styles.rootVideo,
    preload: "none" // IO przełączy na 'auto' przy pierwszym wejściu
    // bez autoPlay – sterujemy programowo (IO + visibility)
    ,

    muted: true,
    loop: true,
    playsInline: true,
    poster: backgroundVideo.poster || undefined,
    ref: videoRef
  }, /*#__PURE__*/React.createElement("source", {
    src: backgroundVideo.src,
    type: backgroundVideo.type || 'video/mp4'
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootOverlay
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), (button === null || button === void 0 ? void 0 : button.label) && /*#__PURE__*/React.createElement("a", {
    className: styles.rootButton,
    href: button.href || '#'
  }, button.label), /*#__PURE__*/React.createElement("div", {
    className: styles.rootAccordion
  }, items.map(({
    heading: itemHeading,
    description
  }, index) => {
    var _itemHeading$toLowerC;
    const isActive = index === activeIndex;
    const contentId = `standards-panel-${index}`;
    const normalizedHeading = (itemHeading === null || itemHeading === void 0 ? void 0 : (_itemHeading$toLowerC = itemHeading.toLowerCase) === null || _itemHeading$toLowerC === void 0 ? void 0 : _itemHeading$toLowerC.call(itemHeading)) || '';
    let IconComponent = EvidenceIcon;
    if (normalizedHeading.includes('czysty skład')) {
      IconComponent = CleanCompositionIcon;
    } else if (normalizedHeading.includes('najwyższa jakość produkcji')) {
      IconComponent = ProductionQualityIcon;
    } else if (normalizedHeading.includes('certyfikowani dostawcy')) {
      IconComponent = CertifiedSupplierIcon;
    } else if (normalizedHeading.includes('eksperckie formuły')) {
      IconComponent = ExpertFormulasIcon;
    } else if (normalizedHeading.includes('udowodniona skuteczność')) {
      IconComponent = EvidenceIcon;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: `${styles.rootAccordionItem} ${isActive ? styles.rootAccordionItemActive : ''}`
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `${styles.rootAccordionSummary} ${isActive ? styles.rootAccordionSummaryActive : ''}`,
      onClick: () => handleToggle(index),
      "aria-expanded": isActive,
      "aria-controls": contentId
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.rootAccordionIcon,
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement(IconComponent, null)), /*#__PURE__*/React.createElement("span", {
      className: styles.rootAccordionTitle,
      dangerouslySetInnerHTML: {
        __html: itemHeading
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.rootAccordionCaret,
      "aria-hidden": "true"
    }, isActive ? /*#__PURE__*/React.createElement(CaretOpen, null) : /*#__PURE__*/React.createElement(CaretClosed, null))), /*#__PURE__*/React.createElement("div", {
      id: contentId,
      className: styles.rootAccordionContent,
      role: "region",
      hidden: !isActive
    }, /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    })));
  }))));
};
export default Standards;